import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import SubmitGem from "./SubmitGem";
import {darkenedBg} from "../../assets/settings";
import chroma from "chroma-js";

class CardFlip extends React.Component {
    constructor(props) {
        super(props);
        this.cardRef = React.createRef();
    }

    setSize() {
        const {store, index} = this.props;
        // console.log('setCardFlipSize: ', index, this.cardRef.current.clientWidth, this.cardRef.current.clientHeight);
        store.setCardFlipSize(index, this.cardRef.current.clientWidth, this.cardRef.current.clientHeight);
    }

    componentDidMount() {
        this.setSize();
    }

    componentDidUpdate() {
        this.setSize();
    }

    render() {
        const {store, index, color, gem} = this.props;
        const isSelected = store.selectedIndices.indexOf(index) >= 0;
        const lightenBorder = () => {
            let ans = chroma(color);
            return ans.mix('#ffffff', 0.2);
        };
        let height = store.interactionsStore.getCardFlipHeight(index) + 50;
        let width = store.interactionsStore.getCardFlipWidth(index);//NOTE: works on load, but resizing is jumpy

        let cardBackClass = 'flip-card-back';
        if (window.chrome) {
            cardBackClass += ' chrome-support';
        }
        return (
            <div className="CardFlip" style={{height: height}}>
                <div className={"flip-card " + (isSelected ? 'show-back' : '')}>
                    <div className="flip-card-inner">
                        <div className="flip-card-front" ref={this.cardRef}>
                            {this.props.frontFace}
                            <SubmitGem store={store} gem={gem} index={index} color={color} width={width}/>
                        </div>
                        <div className={cardBackClass}
                             style={{height: height, background: darkenedBg(color), borderColor: lightenBorder(color)}}>
                            {this.props.backFace}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CardFlip.defaultProps = {
    gem: true
};
export default observer(CardFlip);
